import { createBrowserClient } from '@supabase/ssr'
import { supabaseCookieName } from './cookie-name'

// В dev браузер ходит в Supabase через same-origin прокси (`/supabase/*` →
// rewrites в next.config.ts), а не напрямую по `http://<LAN-IP>:54321`.
// Иначе в режиме `npm run dev:https` (нужен, чтобы на телефоне работал
// микрофон — Web Speech API требует secure context) страница по https тянула
// бы http-ресурсы, и браузер резал бы каждый запрос как mixed content.
// Заодно адрес перестаёт зависеть от того, по какому хосту открыли приложение:
// localhost, 127.0.0.1 или LAN-IP — прокси всегда свой.
function browserSupabaseUrl() {
  if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
    return `${window.location.origin}/supabase`
  }
  return process.env.NEXT_PUBLIC_SUPABASE_URL!
}

export function createClient() {
  return createBrowserClient(browserSupabaseUrl(), process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY!, {
    cookieOptions: { name: supabaseCookieName() },
  })
}
